import * as React from 'react';

import { PageTitleBar } from 'components';

const ProductHeader = ({ children }: React.PropsWithChildren<unknown>) => (
  <PageTitleBar headerTitle={children} />
);

export { ProductHeader };
